import { Pipe, PipeTransform } from '@angular/core';
import { MaybeDate } from '../models/date-helpers.models';

/**
 * passa para dd/MM/yyyy HH'h'mm , se passar 'hideTime' caso hora seja só 0000, coloca ---
 * @param hideTimeIfZeros Passar 'hideTime' se precisar da função de ---
 */
@Pipe({
  name: 'shortDate'
})
export class DateAndTimePipe implements PipeTransform {

  transform(value: MaybeDate, hideTimeIfZeros: 'hideTime' | null = null): string {
    try {
      if (!value) {
        return '--/--/----';
      }

      const date = value instanceof Date ? value : new Date(value);

      const day = ('0' + date.getUTCDate()).slice(-2);
      const month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
      const year = date.getUTCFullYear();

      if (hideTimeIfZeros) {
        return `${day}/${month}/${year}`;
      }

      const hours = ('0' + date.getUTCHours()).slice(-2);
      const minutes = ('0' + date.getUTCMinutes()).slice(-2);

      return `${day}/${month}/${year} ${hours}h${minutes}`;
    } catch (err) {
      return '--/--/----';
    }
  }
}
